// extracted by mini-css-extract-plugin
export default {"items":"Items_items__-v3FZ","list":"Items_list__1bTU1","addButton":"Items_addButton__RK9Qp"};